export default {
  title: 'Components/Scroll Icon/Scroll Icon',
  argTypes: {
    scroll_icon_size: {
      control: { type: 'select' },
      options: ['sm','lg'],
      description: 'Dot color of the scroll icon',
    },
    scroll_icon_color: {
      control: { type: 'select' },
      options: ['black','white'],
      description: 'Dot color of the scroll icon',
    },
    custom_class: {
      control: 'text',
      description: 'Custom class for the scroll icon',
    },
    component_mode: {
      control: { type: 'check' },
      options: ['light-mode'],
      description: 'Mode of the scroll icon component',
    },
  },
  
  parameters: {
    docs: {
      description: {
        component: `
To use the \`dda-scroll-icon\` component, pass the following props:

\`\`\`html
<dda-scroll-icon
    scroll_icon_size="lg"
    scroll_icon_color="black"
    custom_class=""
    component_mode="">
</dda-scroll-icon>
  \`\`\`
`,
      },
    },
  },
};

const Template = (args) => {
  const attributes = Object.entries(args)
    .filter(([value]) => value !== undefined)
    .map(([key, value]) => `${key}="${value}"`)
    .join(' ');

  return `
    <dda-scroll-icon ${attributes}></dda-scroll-icon>
  `;
};

export const Default = Template.bind({});
Default.args = {
  scroll_icon_size: 'lg',
  scroll_icon_color: 'black',
  custom_class: '',
  component_mode: '',
};